import { CoprocessorLogo } from "./CoprocessorLogo";
import { onLinkClick } from "../lib/router";

export function Nav({ onContactClick }: { onContactClick: () => void }) {
  const navItems: Array<[string, string]> = [
    ["#what", "Examples"],
    ["#how", "How it works"],
    ["#vs-jython", "vs Jython"],
    ["#requirements", "Install"],
    ["#pricing", "Pricing"],
  ];

  return (
    <nav
      className="site-nav"
      style={{
        display: "flex",
        alignItems: "center",
        gap: 22,
        padding: "18px 40px",
        borderBottom: "1px solid var(--line)",
        background: "rgba(250,250,245,.85)",
        backdropFilter: "saturate(140%) blur(8px)",
        position: "sticky",
        top: 0,
        zIndex: 20,
        flexWrap: "wrap",
      }}
    >
      <a
        href="/"
        onClick={onLinkClick("/")}
        className="nav-brand"
        style={{
          color: "inherit",
          textDecoration: "none",
          display: "flex",
          alignItems: "center",
          gap: 10,
          fontSize: 16,
          fontWeight: 600,
          whiteSpace: "nowrap",
        }}
      >
        <CoprocessorLogo width={30} height={30} /> Coprocessor
      </a>
      <div
        className="site-nav-links"
        style={{
          marginLeft: "auto",
          display: "flex",
          gap: 6,
          fontSize: 13,
          color: "var(--ink-2)",
          flexWrap: "wrap",
          alignItems: "center",
        }}
      >
        {navItems.map(([href, label]) => (
          <a
            key={href}
            href={href}
            className="site-nav-link"
            style={{ color: "inherit", textDecoration: "none", padding: "7px 9px", borderRadius: 4 }}
          >
            {label}
          </a>
        ))}
        <button
          onClick={onContactClick}
          className="site-nav-link"
          style={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
            color: "inherit",
            fontSize: "inherit",
            padding: "7px 9px",
            borderRadius: 4,
          }}
        >
          Contact
        </button>
      </div>
    </nav>
  );
}
